/**
 * Auth types — ServiceVault contract. Roles are lowercase (JWT claim values).
 * A back-compat `UserRole` enum is retained so existing admin-dashboard imports
 * keep compiling during the phased rewire; its values map to the real roles.
 */
import type { AuthUser, LoginRequest, RegisterRequest, Role, TokenPair } from './domain';

export type { AuthUser, LoginRequest, RegisterRequest, Role, TokenPair };

/** @deprecated Use the lowercase `Role` union. Kept for admin-dashboard compat. */
export enum UserRole {
  ADMIN = 'admin',
  MANAGER = 'manager',
  WORKER = 'worker',
  CUSTOMER = 'customer',
  // legacy aliases (old IoT enum) → nearest cleaning role, so old checks don't crash
  SUPER_ADMIN = 'admin',
  CLIENT = 'customer',
  EDITOR = 'manager',
  VIEWER = 'worker',
  MODERATOR = 'manager',
}

export type User = AuthUser;
export type PublicUser = AuthUser;

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  role?: Role;
}

export interface AuthResponse {
  success: boolean;
  message?: string;
  user?: AuthUser;
  tokens?: TokenPair;
}

export interface ValidationErrors {
  [field: string]: string | undefined;
}
